import React from "react";
import { Typography, Card, CardContent, Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export default function NewCaseStudyCard({
  handleStandard,
  handleMini,
  title = "New",
  icon,
}) {
  return (
    <Box
      sx={{
        position: "relative",
        // display: "inline-block",
        overflow: "visible",
        "&:hover .hover-button": {
          opacity: 1,
          transform: "translate(0, 0)",
          pointerEvents: "auto",
        },
      }}
    >
      {/* Floating Buttons */}
      <Button
        onClick={handleStandard}
        variant="contained"
        size="small"
        className="hover-button"
        sx={{
          position: "absolute",
          top: -16, // move it above the Card
          right: -16, // move it slightly outside
          opacity: 0,
          transform: "translate(0, -10px)",
          transition: "opacity 0.3s, transform 0.3s",
          pointerEvents: "none",
          zIndex: 10,
        }}
      >
        Standard
      </Button>

      <Button
        onClick={handleMini}
        variant="contained"
        size="small"
        className="hover-button"
        sx={{
          position: "absolute",
          bottom: -16, // move it below the Card
          left: -16, // move it slightly outside
          opacity: 0,
          transform: "translate(0, 10px)",
          transition: "opacity 0.3s, transform 0.3s",
          pointerEvents: "none",
          zIndex: 10,
        }}
      >
        Mini
      </Button>
      <Card
        id="new-card"
        elevation={5}
        // sx={{
        //   position: "relative",
        //   minWidth: 275,
        //   overflow: "visible",
        //   p: 2,
        //   "&:hover": {
        //     boxShadow: 6,
        //   },
        // }}
        sx={{
          minHeight: 250,
          m: 0.5,
          position: "relative",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "visible",
          "&:hover": {
            boxShadow: 6,
          },
        }}
      >
        <CardContent sx={{ m: 3 }}>
          {icon || <AddIcon style={{ fontSize: 48, color: "#3f51b5" }} />}
          <Typography variant="h6" color="textSecondary">
            {title}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
